/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerCodeRequest } from '../../models/customer-code-request';
import { CustomerCodeResponse } from '../../models/customer-code-response';

export interface PostApiCustomerV1GenerateCode$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: CustomerCodeRequest
}

export function postApiCustomerV1GenerateCode$Json(http: HttpClient, rootUrl: string, params?: PostApiCustomerV1GenerateCode$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerCodeResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiCustomerV1GenerateCode$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerCodeResponse>;
    })
  );
}

postApiCustomerV1GenerateCode$Json.PATH = '/private/v1/customers/generate-code';
